import { PopupModal } from "react-calendly";
import React, { useEffect, useState } from "react";
import moment from "moment-business-days";
import { AiFillSchedule } from "react-icons/ai";
import { IoCloseOutline } from "react-icons/io5";
import classNames from "classnames";

moment.updateLocale("us", {
  workingWeekdays: [1, 2, 3, 4, 5],
});

function CalendlyWidget({ isCalendlyModalOpen, setIsCalendlyModalOpen }) {
  const [isTipOpen, setIsTipOpen] = useState(true);

  const toggleCalendlyModal = (e) => {
    e.stopPropagation();
    e.preventDefault();
    setIsCalendlyModalOpen(!isCalendlyModalOpen);
  };

  const toggleTip = (e) => {
    e.stopPropagation();
    e.preventDefault();
    setIsTipOpen(!isTipOpen);
  };

  return (
    <>
      <div
        className={classNames("widget-app-container", {
          "widget-app-container-sm": !isTipOpen,
        })}
      >
        {isTipOpen && (
          <div className="JkgJw d-none d-sm-block">
            <div
              role="button"
              aria-haspopup="dialog"
              className="initial-message-bubble"
              aria-label="Open live chat"
              aria-describedby="welcome-message"
            >
              <div
                data-test-id="initial-message-avatar-wrapper"
                className="initial-message-avatar justify-center"
                style={{ top: "-24px" }}
              >
                <div
                  className="justify-center align-center"
                  style={{ height: "48px" }}
                >
                  <div className="kQkusW chat-head-avatar">
                    <div
                      src="https://cdn2.hubspot.net/hub/21905808/hubfs/icon.png?width=108&amp;height=108"
                      className="jpsxTA"
                    ></div>
                    <img
                      src="https://cdn2.hubspot.net/hub/21905808/hubfs/icon.png?width=108&amp;height=108"
                      alt="Avatar of CloudAlgo Team"
                      className="kqmfkk"
                    />
                  </div>
                </div>
              </div>
              <p
                id="welcome-message"
                role="status"
                data-test-id="initial-message-text"
                className="initial-message-text m-top-1 m-bottom-0"
              >
                Need help or have questions? Schedule a time with us.
              </p>
            </div>
            <button
              aria-label="Dismiss"
              shape="circle"
              data-test-id="initial-message-close-button"
              className="cPhjyz fqzmet"
            >
              <div className="cKDyKx">
                <a href="#" onClick={toggleTip}>
                  <IoCloseOutline />
                </a>
              </div>
            </button>
          </div>
        )}
        <div className="launcher">
          <div className="fUOpTB">
            <a href="#" className="widget-icon" onClick={toggleCalendlyModal}>
              <AiFillSchedule />
            </a>
          </div>
        </div>
      </div>

      <PopupModal
        url="https://calendly.com/cloudalgo-sales/30min"
        pageSettings={{
          backgroundColor: "f8f8f8",
          hideEventTypeDetails: true,
          hideLandingPageDetails: true,
          primaryColor: "f75a41",
          textColor: "4d4d4d",
        }}
        prefill={{
          date: moment().businessAdd(2)._d,
        }}
        onModalClose={toggleCalendlyModal}
        open={isCalendlyModalOpen}
        rootElement={document.getElementById("___gatsby")}
      />
    </>
  );
}

export default CalendlyWidget;
